import { OrderDirection } from "_shared/_api/ordering/order-direction";

export abstract class OrderParameters {
  public abstract orderBy: string;
  public abstract orderDir: OrderDirection;

  public get searchParams(): URLSearchParams {
    const params = new URLSearchParams();
    if (this.orderBy) params.append("orderBy", this.orderBy);
    if (this.orderDir) params.append("orderDir", this.orderDir);
    return params;
  }
  public abstract isEqualTo(other: OrderParameters): boolean;
}
